interface PageSectionHeaderProps {
  /** Small uppercase eyebrow text above the title */
  eyebrow: string
  /** Main headline */
  title: string
  /** Right-side content (e.g. nav buttons, "View all" link) */
  actions?: React.ReactNode
  /** Additional classes on the wrapper */
  className?: string
}

/**
 * PageSectionHeader — Compact section header used across hub pages.
 *
 * Orange eyebrow + bold title, left-aligned with optional right-side actions.
 * Smaller and simpler than `SectionHeader` — designed for content sections
 * within hub pages, carousels, and tool/article grids.
 */
export function PageSectionHeader({ eyebrow, title, actions, className = "" }: PageSectionHeaderProps) {
  return (
    <div className={`flex flex-col md:flex-row justify-between items-start md:items-end gap-4 mb-6 ${className}`}>
      <div>
        <span className="text-[#ff9951] font-bold tracking-widest text-xs mb-2 block uppercase">{eyebrow}</span>
        <h2 className="text-2xl md:text-3xl font-black tracking-tighter leading-tight text-gray-900">{title}</h2>
      </div>
      {actions && <div className="flex gap-3">{actions}</div>}
    </div>
  )
}
